import PropTypes from "prop-types";
// @mui
import { Popover } from "@mui/material";
//
import getPosition from "./getPosition";
import { StyledArrow } from "./styles";
import { FONT_PRIMARY, FONT_SECONDARY } from "../../theme/typography";

// ----------------------------------------------------------------------

MenuPopover.propTypes = {
  sx: PropTypes.object,
  open: PropTypes.object,
  children: PropTypes.node,
  disabledArrow: PropTypes.bool,
  arrow: PropTypes.oneOf([
    "top-left",
    "top-center",
    "top-right",
    "bottom-left",
    "bottom-center",
    "bottom-right",
    "left-top",
    "left-center",
    "left-bottom",
    "right-top",
    "right-center",
    "right-bottom",
  ]),
};

export default function MenuPopover({
  open,
  children,
  arrow = "top-right",
  disabledArrow,
  sx,
  ...other
}) {
  const { style, anchorOrigin, transformOrigin } = getPosition(arrow);

  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          p: 1,
          background: "#fff",
          width: "fit-content",
          overflow: "inherit",
          ...style,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
            backgroundColor: "transparent !important",
            "& svg": { mr: 2, width: 20, height: 20, flexShrink: 0 },
            "&:hover": {
              backgroundColor: "rgba(145, 158, 171, 0.08) !important",
            },
          },
          ...sx,
        },
      }}
      {...other}
    >
      {!disabledArrow && <StyledArrow arrow={arrow} />}

      {children}
    </Popover>
  );
}
